export function copyToClipboard(text: string) {
  if (window?.navigator?.clipboard) {
    window.navigator.clipboard.writeText(text);
  }
}
